<template>
  <el-dialog
    v-show="dialogVisible"
    :visible.sync="dialogVisibleShow"
    width="520px">
    <div slot="title" class="dialog-title">
      <h1 class="title">{{dialogData.type==='_PAYMENT'? '支付工资': '申请发票'}}</h1>
    </div>
    <div class="dialog-content">
      <div class="payment-content" v-show="dialogData.type==='_PAYMENT'">
        <p class="p-text">即送报名单</p>
        <div class="part">
          <p>活动方式:</p>
          <p>使用青团宝进行工资支付</p>
        </div>
        <div class="part">
          <p>活动内容:</p> 
          <p>自活动起，首次支付工资累计达500元，即可获得单价为20元的报名单8份，报名单自动到账</p>
        </div>
        <div class="part-footer">
          <p>此活动永久有效 </p>
          <p>此活动与申请发票活动可累计赠送报名单</p>
        </div>
      </div>
      <div class="invoice-content" v-show="dialogData.type==='_INVOICE'">
        <p class="p-text">即送报名单</p>
        <div class="part">
          <p>活动方式:</p>
          <p>通过青团宝线上申请劳务发票</p>
        </div>
        <div class="part">
          <p>活动内容:</p> 
          <p>首次通过青团宝线上申请劳务发票，即可获得单价为20元的报名单10份，报名单自动到账</p>
        </div>
        <div class="part-footer">
          <p>此活动永久有效 </p>
          <p>此活动与支付工资活动可累计赠送报名单</p>
        </div>
      </div> 
    </div>
  </el-dialog>
</template>
<script>
  import {dialogMixin} from 'src/mixin/index'

  export default {
    mixins: [dialogMixin],
    props: {
      dialogData: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {}
    },
    methods: {
      btnCloseDialogClick() {
        this.$emit('update:dialogVisible', false)
      }
    }
  }
</script>
<style lang="less" scoped>
.dialog-title{
  font-size: 20px;
}
.dialog-content{
  margin-top: -30px;
  .payment-content{
    width: 100%;
    height: 100%;
    background: url('https://qiniu-app.qtshe.com/pc-qtbao/20180613/dialog-paument-bg.png') no-repeat center;
    background-size: 100%;
  }
  .invoice-content{
    width: 100%;
    height: 100%;
    background: url('https://qiniu-app.qtshe.com/pc-qtbao/20180613/diglog-invoice-bg.png') no-repeat center;
    background-size: 100%;
  }
  .p-text{
    position: relative;
    top: 0;
    left: 0;
    color: #3C3C3C;
    font-size: 20px;
    margin-bottom: 20px;
    &::after{
      display: block;
      content: '';
      width: 24px;
      height: 5px;
      margin-top: 10px;
      background: #00BBEE;
    }
  }
  .part{
    margin-bottom: 20px;
    color: #3C3C3C;
  }
  .part-footer{
    color: #909090;
  }
}
</style>
/**
* @desc: 弹窗·活动
* @author: zengtiansheng
* @update: 2018/3/17
*/


// WEBPACK FOOTER //
// src/views/home/modules/dialogAct.vue